// Display formatters used by both backend (briefing renderer) and frontend.

const USD = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
});
const USD_M = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 1,
});
const PCT = new Intl.NumberFormat('en-US', {
  style: 'percent',
  minimumFractionDigits: 0,
  maximumFractionDigits: 1,
});
const COMPACT_NUM = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  maximumFractionDigits: 1,
});

export function formatCurrency(value) {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  return USD.format(value);
}

export function formatCurrencyMillions(value) {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  return `${USD_M.format(value / 1_000_000)}M`;
}

export function formatPercent(value, { fractionOf = 1 } = {}) {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  return PCT.format(value / fractionOf);
}

export function formatNumber(value) {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  return COMPACT_NUM.format(value);
}

export function formatDate(value, { withTime = false } = {}) {
  if (!value) return '—';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  if (withTime) {
    return d.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  }
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: '2-digit' });
}

export function relativeFromNow(value, now = new Date()) {
  if (!value) return '—';
  const target = value instanceof Date ? value : new Date(value);
  const diffMs = target.getTime() - now.getTime();
  const absH = Math.round(Math.abs(diffMs) / 3_600_000);
  if (absH < 1) return diffMs >= 0 ? 'in <1h' : '<1h ago';
  if (absH < 24) return diffMs >= 0 ? `in ${absH}h` : `${absH}h ago`;
  const days = Math.round(absH / 24);
  return diffMs >= 0 ? `in ${days}d` : `${days}d ago`;
}

export function titleCase(s) {
  return String(s ?? '')
    .replace(/[-_]+/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function healthLabel(h) {
  switch (h) {
    case 'green':
      return 'On track';
    case 'amber':
      return 'At risk';
    case 'red':
      return 'Critical';
    default:
      return 'Unknown';
  }
}
